module.exports = __webpack_public_path__ + "fonts/EMprint-BoldItalic.b61f3ce6.ttf";